<!--<div class="beta-frame-wrapper">-->
<!--  <iframe-->
<!--    class="beta-frame"-->
<!--    [src]="betaUrl"-->
<!--    title="FAANG Validator Beta"-->
<!--    loading="lazy"-->
<!--  ></iframe>-->
<!--</div>-->




<br>
<iframe width="100%"
        height="100%"
        src="https://faang-validator-frontend-964531885708.europe-west2.run.app/"
        frameborder="0" style="border:0" allowfullscreen
        sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups
        allow-popups-to-escape-sandbox" onload="this.width=screen.width;this.height=screen.height;"></iframe>
